<template>
  <div v-if="show" class="printjob-modal-overlay" @click="closeModal">
    <div class="printjob-modal-content" @click.stop>
      <div class="printjob-modal-header">
        <h3>Print Job Completed</h3>
        <button @click="closeModal" class="printjob-modal-close-btn">&times;</button>
      </div>
      <div class="printjob-modal-body">
        <div class="printjob-print-status-info">
          <div class="printjob-status-icon">🖨️</div>
          <div class="printjob-status-message">
            <p><strong>{{ printedChecksCount }} check(s) have been sent to the printer.</strong></p>
            <p>Please check your printer to confirm the checks were printed successfully.</p>
          </div>
        </div>
        <div class="printjob-confirmation-question">
          <p><strong>Is your print job completed successfully?</strong></p>
          <p class="printjob-help-text">Click "Yes, Done" only if you have confirmed the checks printed correctly.</p>
        </div>
      </div>
      <div class="printjob-modal-footer">
        <button 
          @click="confirmPrintJobDone" 
          class="printjob-btn printjob-btn-success"
          :disabled="updatingStatus"
        >
          <span v-if="updatingStatus">🔄 Updating...</span>
          <span v-else>✅ Yes, Done</span>
        </button>
        <button 
          @click="printJobNotDone" 
          class="printjob-btn printjob-btn-secondary"
          :disabled="updatingStatus"
        >
          ❌ No, Not Done
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import './PrintJobCompletedModal.css';

export default {
  name: 'PrintJobCompletedModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    printedChecksCount: {
      type: Number,
      default: 0
    },
    updatingStatus: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirmPrintJobDone() {
      this.$emit('confirm-done');
    },
    printJobNotDone() {
      this.$emit('not-done');
    }
  }
}
</script>
